import { useState, useEffect } from "react";
import api from "@/lib/api";
import { AUTH_DISABLED } from "@/lib/constants";
import { useAuth } from "@/context/AuthContext";

// Rang-basierte Rechte (Voll-Matrix). Lädt /api/rank-permissions und prüft
// can(capability) über den Rang des eingeloggten Nutzers.
export function usePermissions() {
  const { user } = useAuth();
  const [matrix, setMatrix] = useState(null);

  useEffect(() => {
    if (AUTH_DISABLED) return;
    api.get("/rank-permissions").then((r) => setMatrix(r.data)).catch(() => setMatrix({}));
  }, []);

  const can = (capability) => {
    if (AUTH_DISABLED) return true;
    if (!user) return false;
    // Master-Account (Administration) hat immer vollen Zugriff.
    if (user.name === "Administration") return true;
    if (!matrix) return false;
    return !!matrix[user.rang]?.[capability];
  };

  return { can, ready: AUTH_DISABLED || !!matrix };
}
